import React, { forwardRef } from 'react';

interface WaveformLogoProps {
  size?: number;
  color?: string;
  variant?: 'color' | 'monochrome' | 'white';
  className?: string;
}

export const WaveformLogo = forwardRef<SVGSVGElement, WaveformLogoProps>(({
  size = 64,
  color = '#7C3AED',
  variant = 'color',
  className,
}, ref) => {
  const primaryColor = variant === 'monochrome' ? '#1F1F1F' : variant === 'white' ? '#FFFFFF' : color;
  const accentColor = variant === 'monochrome' ? '#6B6B6B' : variant === 'white' ? 'rgba(255,255,255,0.7)' : '#A78BFA';
  const lightColor = variant === 'monochrome' ? '#9E9E9E' : variant === 'white' ? 'rgba(255,255,255,0.5)' : '#C4B5FD';

  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Bold equalizer bars forming a K shape */}

      {/* Vertical bar of K */}
      <rect x="15" y="20" width="8" height="60" rx="4" fill={primaryColor} />

      {/* Upper diagonal - bars getting taller */}
      <rect x="30" y="35" width="6" height="15" rx="3" fill={accentColor} />
      <rect x="40" y="30" width="6" height="20" rx="3" fill={primaryColor} />
      <rect x="50" y="25" width="6" height="25" rx="3" fill={lightColor} />
      <rect x="60" y="20" width="6" height="30" rx="3" fill={accentColor} />
      <rect x="70" y="15" width="6" height="35" rx="3" fill={primaryColor} />

      {/* Lower diagonal - bars getting taller */}
      <rect x="30" y="60" width="6" height="15" rx="3" fill={lightColor} />
      <rect x="40" y="60" width="6" height="20" rx="3" fill={accentColor} />
      <rect x="50" y="60" width="6" height="25" rx="3" fill={primaryColor} />
      <rect x="60" y="60" width="6" height="30" rx="3" fill={lightColor} />
      <rect x="70" y="60" width="6" height="35" rx="3" fill={accentColor} />
    </svg>
  );
});

WaveformLogo.displayName = 'WaveformLogo';

export default WaveformLogo;
